<template lang="pug">
div
	page-header(:title='title')
	form(@submit.prevent='gravar')
		.modal-body
			.form-horizontal
				vue-element-loading(:active='isActive', spinner='bar-fade-scale', color='#428BCA')
				input-form-text(textInput='Título', :required='true', v-model='form.titulo', :value='form.titulo')
				input-form-text(textInput='Ano', :required='true', v-model='form.ano', :value='form.ano', type='number')
				input-form-text(textInput='URL Youtube', :required='true' v-model='url', :value='url' v-debounce:1000ms="get_video_id")
				.form-group(v-if="urlImg")
					label.col-sm-3.control-label.no-padding-right Imagem
					.col-sm-9
						a(:href="url" target="_blank")
							img.h-48(:src="urlImg")
				input-form-text(textInput='Chave Youtube' disabled :value='form.url')
				.form-group
					select-form(v-model='form.ativo', :value='form.ativo', name='Ativo', url='/arquivos', id='id', titulo='nome', layout='true', optionText='Selecione', required='true')
		footer-button(:disabled='isActive')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import SelectForm from '@/components/form/SelectForm'
import Permission from '@/mixins/Permission'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'

export default {
	components: {
		PageHeader,
		InputFormText,
		FooterButton,
		SelectForm,
		VueElementLoading
	},
	mixins: [Permission],
	computed: {
		...mapGetters([
			'user'
		])
	},
	data() {
		return {
			title: 'Vídeos',
			form: {
				titulo: '',
				ano: new Date().getFullYear().toString(),
				url: '',
				ativo: '1'
			},
			url: '',
			urlImg: '',
			isActive: false,
			textMatch: null
		}
	},
	methods: {
		...mapActions([
			'getLogsTotal'
		]),
		async gravar() {
			this.isActive = true
			const body = {
				...this.form,
				ano: Number(this.form.ano) || new Date().getFullYear(),
			}
			//this.setVersion()
			if (this.$route.params.id) {
				await req(`/v1/videos/${this.$route.params.id}`, 'put', body).catch(response => {
					'error: ' + response
					erro()
				})
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/site/videos')
				
			} else {
				await req('/v1/videos', 'post', body).catch(response => {
					'error: ' + response
					erro()
				})
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/site/videos')
			}
			this.isActive = false
		},
		get_video_id() {
			let input = this.url
			if(!input) return
			// eslint-disable-next-line no-useless-escape
			let textMatch = input.match(/(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/user\/\S+|\/ytscreeningroom\?v=|\/sandalsResorts#\w\/\w\/.*\/))([^\/&]{10,12})/)
			if(!textMatch) return
			this.urlImg = `http://img.youtube.com/vi/${textMatch[1]}/hqdefault.jpg`
			this.form.url = textMatch[1]
		},
		async setVersion() {
			const dados = await req('/versao/1', 'put', {
				title: Date.now()
			})
			dados
		},
		async getDados() {
			const resp = await req(`/v1/videos/${this.$route.params.id}`).catch(response => {
				'error: ' + response
				erro()
			})
			this.form.ativo = resp.ativo
			this.form.titulo = resp.titulo
			this.form.ano = resp.ano ? String(resp.ano) : new Date().getFullYear().toString()
			this.form.url = resp.url
			this.url = resp.url ? `https://www.youtube.com/embed/${resp.url}` : ''
			this.urlImg = resp.url ? `http://img.youtube.com/vi/${resp.url}/hqdefault.jpg` : ''
			this.isActive = false
		},
		verifPermissao() {
			if (this.$route.params.id) {
				if (!this.ACTION.e) {
					this.$router.push('/erro')
				}
			} else {
				if (!this.ACTION.c) {
					this.$router.push('/erro')
				}
			}
		}
	},
	mounted() {
		this.verifPermissao()
		if (this.$route.params.id) {
			this.isActive = true
			this.getDados()
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>
